import Vue from 'vue'
import axios from 'axios'

const initState = {}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {},
  actions: {
    uploadGalleryImage({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`images/upload-gallery-image`, params)
          .then((res) => resolve(res.data.data))
          .catch((err) => reject(err))
      })
    },
    uploadLogoImage({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`images/upload-logo-image`, data)
          .then((res) => resolve(res.data.data))
          .catch(() => reject(data))
      })
    },
    uploadNonConvertImage({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`images/upload-non-convert-image`, data)
          .then((res) => resolve(res.data.data))
          .catch((err) => reject(err))
      })
    },
    uploadImage({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`images/upload-image`, data)
          .then((res) => resolve(res.data.data))
          .catch(() => reject(data))
      })
    },
    rotateMediaLibrary({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/media-library/${params.library_id}/rotate`, params)
          .then((res) => resolve(res.data.item))
          .catch((error) => reject(error))
      })
    },
    updateMediaLibrary({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/media-library/${params.library_id}`, params)
          .then((res) => resolve(res.data.item))
          .catch((error) => reject(error))
      })
    },
    getSpecificMediaLibraryObject({ commit }, { libraryIds }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/media-library/specific/object?libraryIds=${libraryIds.join(',')}`)
          .then((res) => resolve(res.data.items))
          .catch((error) => reject(error))
      })
    },
    getSpecificMediaLibrary({ commit }, { libraryIds }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/media-library/specific?libraryIds=${libraryIds.join(',')}`)
          .then((res) => resolve(res.data.items))
          .catch((error) => reject(error))
      })
    },
    getMediaLibrary({ commit }, params) {
      let url = '/media-library/all'
      const parts = []
      for (let key in params) {
        if (params[key]) {
          parts.push(`${key}=${params[key]}`)
        }
      }
      if (parts.length) url = `${url}?${parts.join('&')}`
      return new Promise((resolve, reject) => {
        axios
          .get(url)
          .then((res) => resolve(res.data.items))
          .catch((error) => reject(error))
      })
    },
    distributeMediaLibrary({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/media-library/distribute`, params)
          .then((res) => resolve(res.data.items))
          .catch((error) => reject(error))
      })
    },
    getUnsplashImages({ commit }, { query, page }) {
      return new Promise((resolve, reject) => {
        axios
          .get(
            `https://api.unsplash.com/search/photos?per_page=12&orientation=landscape&query=${query}&page=${page}`,
            { headers: { Authorization: `Client-ID ${process.env.VUE_APP_UNSPLASH_ACCESS_TOKEN}` } }
          )
          .then((res) => resolve(res.data.results))
          .catch((err) => reject(err))
      })
    },
    generateAIImage({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`images/generate-ai-image`, data)
          .then((res) => resolve(res.data.data))
          .catch((err) => reject(err))
      })
    },
    editAIImage({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`images/edit-ai-image`, data)
          .then((res) => resolve(res.data.data))
          .catch((err) => reject(err))
      })
    },
  },
  getters: {}
}